import React from 'react';

export const InlineLoadingIndicator = () => (
  <svg className="lds-spin" width="64px" height="64px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style={{background: 'none'}}>
    <g transform="translate(75,50)">
      <g transform="rotate(0)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="1" transform="scale(1.01705 1.01705)">
          <animateTransform attributeName="transform" type="scale" begin="-1.1818181818181819s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-1.1818181818181819s"></animate>
        </circle>
      </g>
    </g>
    <g transform="translate(71.03133832077953,63.51602043638994)">
      <g transform="rotate(32.72727272727273)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.9090909090909091" transform="scale(1.02615 1.02615)">
          <animateTransform attributeName="transform" type="scale" begin="-1.0636363636363637s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-1.0636363636363637s"></animate>
        </circle>
      </g>
    </g>
    <g transform="translate(60.385375325047164,72.74079988386296)">
      <g transform="rotate(65.45454545454545)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.8181818181818182" transform="scale(1.03524 1.03524)">
          <animateTransform attributeName="transform" type="scale" begin="-0.9454545454545454s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.9454545454545454s"></animate>
        </circle>
      </g>
    </g><g transform="translate(46.442129043167874,74.74553604702332)">
      <g transform="rotate(98.18181818181817)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.7272727272727273" transform="scale(1.04433 1.04433)">
          <animateTransform attributeName="transform" type="scale" begin="-0.8272727272727273s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.8272727272727273s"></animate>
        </circle>
      </g>
    </g><g transform="translate(33.62848165136788,68.89373935885646)">
      <g transform="rotate(130.9090909090909)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.6363636363636364" transform="scale(1.05342 1.05342)">
          <animateTransform attributeName="transform" type="scale" begin="-0.7090909090909091s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.7090909090909091s"></animate>
        </circle>
      </g>
    </g><g transform="translate(26.012675659637566,57.04331392103574)">
      <g transform="rotate(163.63636363636365)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.5454545454545454" transform="scale(1.06251 1.06251)">
          <animateTransform attributeName="transform" type="scale" begin="-0.5909090909090909s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.5909090909090909s"></animate>
        </circle>
      </g>
    </g><g transform="translate(26.012675659637562,42.95668607896427)">
      <g transform="rotate(196.36363636363635)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.45454545454545453" transform="scale(1.0716 1.0716)">
          <animateTransform attributeName="transform" type="scale" begin="-0.4727272727272727s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.4727272727272727s"></animate>
        </circle>
      </g>
    </g><g transform="translate(33.62848165136787,31.106260641143546)">
      <g transform="rotate(229.0909090909091)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.36363636363636365" transform="scale(1.08069 1.08069)">
          <animateTransform attributeName="transform" type="scale" begin="-0.35454545454545455s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.35454545454545455s"></animate>
        </circle>
      </g>
    </g><g transform="translate(46.44212904316787,25.254463952976682)">
      <g transform="rotate(261.8181818181818)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.2727272727272727" transform="scale(1.08978 1.08978)">
          <animateTransform attributeName="transform" type="scale" begin="-0.23636363636363636s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.23636363636363636s"></animate>
        </circle>
      </g>
    </g><g transform="translate(60.38537532504715,27.259200116137038)">
      <g transform="rotate(294.54545454545456)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.18181818181818182" transform="scale(1.09887 1.09887)">
          <animateTransform attributeName="transform" type="scale" begin="-0.11818181818181818s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="-0.11818181818181818s"></animate>
        </circle>
      </g>
    </g><g transform="translate(71.03133832077953,36.48397956361006)">
      <g transform="rotate(327.2727272727273)">
        <circle cx="0" cy="0" r="5" fill="#646464" fillOpacity="0.09090909090909091" transform="scale(1.00796 1.00796)">
          <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1" keyTimes="0;1" dur="1.3s" repeatCount="indefinite"></animateTransform>
          <animate attributeName="fill-opacity" keyTimes="0;1" dur="1.3s" repeatCount="indefinite" values="1;0" begin="0s"></animate>
        </circle>
      </g>
    </g>
  </svg>
);
